import React, { useEffect, useState, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import Button from '../../../Components/Button';
import FormManager from '../../../Components/FormManager';
import InputManager from '../../../Components/InputManager';
import { validateEmail, validateMobile } from '../../../helpers/helper';
import {
  submitSeminarAudience,
  submitSeminarRazorpayOrders,
  seminarRegistration
} from '../../../actions/seminars';
import './style.css';
import { RESET_FLAGS } from '../../../constants/actionTypes';
import { RAZORPAY_KEY } from '../../../config.local';
import Alert from '../../../Components/Alert';
import { branchOptions, stateOptions } from './constants';

let resetRegForm;

const WorkshopRegForm = ({
  seminarId,
  fees,
  submitSeminarAudience,
  submitSeminarRazorpayOrders,
  seminarRegistration,
  t,
  isLoading,
  isError,
  registrationStatus,
  toggleRegistrationVisibility
}) => {
  const dispatch = useDispatch();
  const seminarData = {
    email: '',
    mobile: '',
    name: '',
    semester: null,
    branch: null,
    state: null,
    college: '',
    city: '',
    referralCode: ''
  };
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);
  const [user, setUser] = useState({});
  const [order, setOrder] = useState({});
  const resetFlags = useCallback(() => {
    dispatch({
      type: RESET_FLAGS
    });
  }, [dispatch]);
  const {
    email,
    mobile,
    name,
    college,
    semester,
    branch,
    state,
    city,
    referralCode
  } = seminarData;
  const validateName = val => val.trim().length < 3;
  const emailValidation = val => !validateEmail(val.trim());
  const phoneValidation = val => !validateMobile(val.trim());
  const textValidation = val => val.trim().length <= 0;
  const numberValidation = val => !Number.isInteger(Number(val));

  const onSubmit = async (data, resetForm) => {
    data['seminar_id'] = seminarId;
    resetRegForm = resetForm;
    try {
      const participant = await submitSeminarAudience(data);
      const seminarParticipant = participant.data;
      setUser(seminarParticipant);
    } catch (err) {}
  };
  useEffect(() => {
    if (user && Object.keys(user).length !== 0 && user.constructor === Object) {
      handleOrder();
    }
  }, [user]);
  useEffect(() => {
    if (
      order &&
      Object.keys(order).length !== 0 &&
      order.constructor === Object
    ) {
      const options = {
        key: RAZORPAY_KEY,
        amount: parseFloat(fees) * 100,
        name: 'Workshop',
        description: 'Registration fees for Workshop',
        order_id: order.attributes.razorpayOrderId,
        handler: handlePayment,
        prefill: {
          name: user.attributes.name,
          email: user.attributes.email,
          contact: user.attributes.phone,
          state: user.attributes.state,
          city: user.attributes.city,
          semester: user.attributes.semester,
          branch: user.attributes.branch,
          college: user.attributes.college
        },
        notes: {},
        theme: {
          color: '#000853'
        },
        modal: {
          ondismiss: () => {}
        }
      };

      // eslint-disable-next-line no-undef
      const rzp1 = new Razorpay(options);
      rzp1.open();
    }
  }, [order]);

  const handleOrder = async () => {
    if (!user) {
      throw Error('No saved user present');
    }
    const razorpayParams = {
      amount: fees,
      seminar_audience_id: user.id,
      seminar_id: user.attributes.seminarId
    };
    try {
      const orders = await submitSeminarRazorpayOrders(razorpayParams);
      const orderData = orders.data;
      setOrder(orderData);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePayment = async response => {
    const seminarRegBody = {
      seminar_audience_id: user.id,
      seminar_id: user.attributes.seminarId,
      razorpay_signature: response.razorpay_signature,
      seminar_razorpay_order_id: response.razorpay_order_id,
      razorpay_payment_id: response.razorpay_payment_id
    };
    try {
      await seminarRegistration(seminarRegBody);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (registrationStatus.success || registrationStatus.failed) {
      setTimeout(() => {
        resetFlags();
        resetRegForm();
      }, 3000);
    }
  }, [registrationStatus.success, registrationStatus.failed]);
  return (
    <FormManager
      className={
        !registrationStatus.success && !registrationStatus.failed
          ? 'register_form'
          : 'after_form_submit_register_form'
      }
      onSubmit={onSubmit}>
      {!registrationStatus.success && !registrationStatus.failed && (
        <React.Fragment>
          <h2>Register Now</h2>
          <InputManager
            id="name"
            placeholder="Enter your name"
            className="contact-form-field"
            value={name}
            validate={validateName}
            required={true}
            emptyText={t('nameEmptyText')}
            invalidText={t('nameInvalidText')}
          />

          <InputManager
            id="email"
            placeholder="Enter email id"
            className="contact-form-field"
            value={email}
            validate={emailValidation}
            required={true}
            emptyText={t('emailEmptyText')}
            invalidText={t('emailInvalidText')}
          />

          <InputManager
            id="phone"
            placeholder="Enter phone number"
            className="contact-form-field"
            value={mobile}
            validate={phoneValidation}
            required={true}
            emptyText={t('phoneEmptyText')}
            invalidText={t('phoneInvalidText')}
          />

          <InputManager
            id="college"
            placeholder={t('inputCollege')}
            className="contact-form-field"
            value={college}
            validate={textValidation}
            emptyText="Cannot be empty"
            invalidText="Invalid college"
          />

          <InputManager
            id="semester"
            type="number"
            placeholder="Enter Semester (Number)"
            className="contact-form-field"
            value={semester}
            validate={numberValidation}
            emptyText="Cannot be empty"
            invalidText="Semester must be an integer"
          />

          <InputManager
            id="branch"
            type="select"
            className="contact-form-field"
            value={branch}
            placeholder="Branch"
            options={branchOptions}
            validate={textValidation}
            required={true}
            emptyText="Branch cannot be empty"
          />

          <InputManager
            id="city"
            placeholder={t('inputCity')}
            className="contact-form-field"
            value={city}
            validate={textValidation}
            required={true}
            emptyText="City cannot be empty"
            invalidText="Invalid city name"
          />

          <InputManager
            id="state"
            type="select"
            className="contact-form-field"
            value={state}
            placeholder="State"
            options={stateOptions}
            validate={textValidation}
            required={true}
            emptyText="State cannot be empty"
          />

          <div className="reg_submit_btn_container">
            <Button
              autoSize
              indicatorColor="white"
              className="reg_submit_btn"
              loading={isLoading || registrationStatus.start}
              type="submit"
              text="Register"
            />
          </div>
        </React.Fragment>
      )}

      {registrationStatus.success && (
        <div className="registration_message_box">
          <h3 className="success_registration">
            You have successfully registered for the workshop. Please check your
            email for confirmation.
          </h3>
        </div>
      )}
      {registrationStatus.failure && (
        <div className="registration_message_box">
          <h3 className="failed_registration">Registration Failed</h3>
        </div>
      )}
    </FormManager>
  );
};

const mapStateToProps = (store, props) => ({
  isLoading: store.seminarData.postAudience.loading,
  isError: store.seminarData.postAudience.error,
  registrationStatus: {
    start: store.seminarData.seminarRegistration.start,
    success: store.seminarData.seminarRegistration.success,
    failure: store.seminarData.seminarRegistration.failed
  }
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      submitSeminarAudience,
      submitSeminarRazorpayOrders,
      seminarRegistration
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(WorkshopRegForm));



// WEBPACK FOOTER //
// ./src/Pages/Workshop/RegistrationForm/index.js